import { memo } from 'react';
import AnswerMessageHeader from 'components/message/AnswerMessageHeader';

import styles from '../answer-message.scss';

// We could just pass this component as a prop to "BaseMessage", but it would cause a re-render on
// the AnswerMessageHeader. We could refactor the "BaseMessage" to receive this as "children" instead of a prop, but since BaseMessage is used on other
// places, it would demand refactor on other components, which might be too much for one ticket. For now we just memoize this component and pass it as a prop.
const AnswerMessageHeaderContainer = memo(
  ({ title, filters, message, answerId, messageId, referenceTo, localQuestionId, isMobile, summary, miniBoard }) => {
    return (
      <div className={styles.wrap}>
        <div>
          <AnswerMessageHeader
            structuredTitle={title}
            filters={filters}
            answerData={message}
            answerId={answerId}
            id={messageId}
            referenceTo={referenceTo}
            localQuestionId={localQuestionId}
            isMobile={isMobile}
          />
          {summary && <p className={styles.pendingBoard}>{summary}</p>}
          {miniBoard}
        </div>
        <div className={styles.placeholder} />
      </div>
    );
  }
);

export default AnswerMessageHeaderContainer;
